import { camelCase } from 'lodash'

const createMutationSet = type => ({
  BASE: `${type}`,
  urlKey: `${camelCase(type)}Url`,
  stateKey: `${camelCase(type)}State`,
  promiseKey: `${camelCase(type)}Promise`,
  cancelSource: `${camelCase(type)}cancelSource`,
  statusCodeKey: `${camelCase(type)}StatusCode`,
  errorMessageKey: `${camelCase(type)}ErrorMessage`,
  dataKey: `${camelCase(type)}Data`,
  requestCount: `${camelCase(type)}RequestCount`,
})

export const BASKET = createMutationSet('BASKET')
export const OPTIONS = createMutationSet('OPTIONS')
export const SEARCH = createMutationSet('SEARCH')
export const CUSTOMER = createMutationSet('CUSTOMER')
export const SERVICE = createMutationSet('SERVICE')
export const ORDER = createMutationSet('ORDER')
export const PRODUCTS = createMutationSet('PRODUCTS')
export const PRODUCT = createMutationSet('PRODUCT')
export const PRODUCTSPAREPARTS = createMutationSet('PRODUCTSPAREPARTS')
export const CLIENT = createMutationSet('CLIENT')
export const COMPARE = createMutationSet('COMPARE')
export const FAVORITE = createMutationSet('FAVORITE')
export const FAVORITEPRODUCTS = createMutationSet('FAVORITEPRODUCTS')
export const AVAILABILITYWATCH = createMutationSet('AVAILABILITYWATCH')
export const PRODUCTATTRIBUTES = createMutationSet('PRODUCTATTRIBUTES')
export const BLOCKINGREASONS = createMutationSet('BLOCKINGREASONS')

export default {
  BASKET,
  OPTIONS,
  SEARCH,
  CUSTOMER,
  SERVICE,
  ORDER,
  PRODUCTS,
  PRODUCT,
  CLIENT,
  FAVORITE,
  FAVORITEPRODUCTS,
  PRODUCTSPAREPARTS,
  PRODUCTATTRIBUTES,
  COMPARE,
  AVAILABILITYWATCH,
  BLOCKINGREASONS,
}
